<template>
	<div class="table__refinement">
		<helio-search
			v-if="search"
			:placeholder="search.placeholder"
			@search="$emit('search', $event)"
		/>

		<helio-filters
			:items="items"
			:filters="filters"
			:loading="loading"
			@filter="$emit('filter', $event)"
		/>
	</div>
</template>

<script>
import Search from '../search/Search.vue';
import Filters from '../filters/Filters.vue';

export default {
	name: 'Refinement',

	components: {
		'helio-filters': Filters,
		'helio-search': Search,
	},

	props: {
		items: {
			type: Array,
			required: true,
		},

		filters: {
			type: Array,
			required: false,
			default: null,
		},

		loading: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the filters will be shown in its loading state',
		},

		search: {
			type: Object,
			required: false,
			default: null,
		},
	},
};
</script>

<style lang="text/scss" src="./refinement.scss" />
